import { Box, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocaleState, useTranslate, SimpleForm } from "react-admin";
import { roundUpAndReturnNum } from "../../../utils/roundUpAndReturnNum";

export const CarnetForm = ({
    onCancel,
    onSave,
    record,
    action,
    isAdditionalRow,
}) => {
    const translate = useTranslate();
    const [locale] = useLocaleState();
    const disabled = action === "edit" && !isAdditionalRow;
    const [formValues, setFormValues] = useState({
        description: "",
        labelNumber: "",
        serialNumber: "",
        quantity: "",
        weight: "",
        carnetPrice: "",
        originCountry: "",
    });

    useEffect(() => {
        if (action === "edit" && isAdditionalRow) {
            setFormValues(record);
        } else if (action === "edit" && !isAdditionalRow) {
            const quantity =
                record?.carnetData?.quantity || record.quantity || 0;
            const weight =
                record?.carnetData?.weight ||
                record.sku?.weight ||
                record.product.weight ||
                record.weight ||
                0;
            const carnetPrice =
                record?.carnetData?.carnetPrice ||
                record.product.carnetPrice ||
                0;
            setFormValues({
                description: `${record.product.name[locale]} ${record.product.description[locale]}`,
                labelNumber: record.labelNumber || "",
                serialNumber: record.sku?.serialNumber || "N/A",
                quantity: roundUpAndReturnNum(quantity),
                weight: roundUpAndReturnNum(weight),
                carnetPrice: roundUpAndReturnNum(carnetPrice),
                originCountry: record.product.originCountry || "",
            });
        }
    }, [record, action, isAdditionalRow, locale]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        const parsedData = {
            ...formValues,
            quantity: parseInt(formValues.quantity || 0),
            weight: parseFloat(formValues.weight) || 0,
            carnetPrice: parseFloat(formValues.carnetPrice) || 0,
        };
        onSave(parsedData);
    };

    return (
        <SimpleForm
            onChange={handleChange}
            toolbar={<Toolbar onCancel={onCancel} onSave={handleSave} />}
        >
            <TextField
                name="description"
                label={translate("equip.description")}
                title={translate("equip.description")}
                disabled={disabled}
                defaultValue={formValues.description}
            />
            <TextField
                name="labelNumber"
                label={translate("equip.labelNumber")}
                title={translate("equip.labelNumber")}
                disabled={disabled}
                defaultValue={formValues.labelNumber}
            />
            <TextField
                name="serialNumber"
                label={translate("equip.serialNumber")}
                title={translate("equip.serialNumber")}
                disabled={disabled}
                defaultValue={formValues.serialNumber}
            />
            <TextField
                name="quantity"
                label={translate("equip.quantity")}
                title={translate("equip.quantity")}
                defaultValue={formValues.quantity}
                type="number"
            />
            <TextField
                name="weight"
                label={`${translate("equip.weight")}
        ${translate("equip.perItem")}`}
                title={`${translate("equip.weight")}
        ${translate("equip.perItem")}`}
                defaultValue={formValues.weight}
                type="number"
                slotProps={{ htmlInput: { step: "0.01" } }}
            />
            <TextField
                name="carnetPrice"
                label={`${translate("equip.carnetPrice")}
        ${translate("equip.perItem")}`}
                title={`${translate("equip.carnetPrice")}
        ${translate("equip.perItem")}`}
                defaultValue={formValues.carnetPrice}
                type="number"
                slotProps={{ htmlInput: { step: "0.01" } }}
            />
            <TextField
                name="originCountry"
                label={translate("equip.originCountry")}
                title={translate("equip.originCountry")}
                defaultValue={formValues.originCountry}
                disabled={disabled}
            />
        </SimpleForm>
    );
};

const Toolbar = ({ onSave, onCancel }) => {
    const translate = useTranslate();

    return (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={onCancel}>{translate("equip.cancel")}</Button>
            <Button onClick={onSave}>{translate("equip.save")}</Button>
        </Box>
    );
};
